/* ============================================================
   A11y remediation — 2026-08-25
   1) Sepet değişikliklerini ekran okuyucuya duyurur (WCAG 4.1.3)
   2) CPS garanti penceresine dialog semantiği + odak yönetimi
   3) CPS plan aç/kapa butonuna erişilebilir ad
   4) x-tabs sekmelerine tablist ebeveyni
   Tema koduna değil, uygulamaların enjekte ettiği DOM'a da dokunur;
   bu yüzden MutationObserver ile geç gelen öğeleri de yakalar.
   ============================================================ */
(function () {
  'use strict';

  /* ---- 1. canlı duyuru bölgesi + sepet duyurusu ---- */
  var live = document.createElement('div');
  live.id = 'a11y-live';
  live.className = 'a11y-sr-only';
  live.setAttribute('role', 'status');
  live.setAttribute('aria-live', 'polite');

  var lastCount = null;
  function announce(msg) {
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 60);
  }
  function onCartChange(e) {
    var cart = e.detail && (e.detail.cart || e.detail);
    var n = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
    if (n === null) { announce('Cart updated.'); return; }
    var items = n === 1 ? '1 item.' : n + ' items.';
    if (lastCount === null || n > lastCount) announce('Added to your cart. Cart now has ' + items);
    else if (n < lastCount) announce('Item removed. Cart now has ' + items);
    else announce('Cart updated. Cart has ' + items);
    lastCount = n;
  }
  document.documentElement.addEventListener('cart:change', onCartChange);
  document.addEventListener('cart:change', onCartChange); // kabarcıklanmazsa diye çift kayıt; dataset ile tekille
  var lastMsgAt = 0;
  var _announce = announce;
  announce = function (msg) { // 300ms içinde çift tetiklenirse tekle
    var now = Date.now();
    if (now - lastMsgAt < 300) return;
    lastMsgAt = now; _announce(msg);
  };

  /* ---- 2. CPS araya giren penceresi (#modalMainjump2) ---- */
  var prevFocus = null;
  var cpsFocusTick = null;
  function patchCpsModal() {
    var m = document.getElementById('modalMainjump2');
    if (!m || m.dataset.a11yPatched) return;
    m.dataset.a11yPatched = '1';
    m.setAttribute('role', 'dialog');
    m.setAttribute('aria-modal', 'true');
    m.setAttribute('aria-label', 'Extended warranty offer');
    var close = m.querySelector('button.close');
    if (close && !close.getAttribute('aria-label')) close.setAttribute('aria-label', 'Close warranty offer');

    function visible() {
      var s = getComputedStyle(m);
      return s.display !== 'none' && s.visibility !== 'hidden' && m.getBoundingClientRect().height > 50;
    }
    function focusIn() {
      if (!visible() || m.contains(document.activeElement)) return;
      prevFocus = document.activeElement;
      var f = m.querySelector('.button-link, button, a[href]');
      if (f) { f.focus(); announce('Extended warranty offer dialog opened.'); }
    }
    if (visible()) focusIn();
    new MutationObserver(focusIn).observe(m, { attributes: true, attributeFilter: ['style', 'class'] });
    cpsFocusTick = focusIn; // patchAll her turda dener (icerik-ekleyerek acilma durumu)

    m.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && close) {
        close.click();
        if (prevFocus && prevFocus.focus) prevFocus.focus();
      }
      if (ev.key === 'Tab') { // basit odak tuzağı
        var focusables = m.querySelectorAll('button, a[href], input, select, [tabindex]:not([tabindex="-1"])');
        if (!focusables.length) return;
        var first = focusables[0], last = focusables[focusables.length - 1];
        if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
        else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
      }
    });
    // kapatma tıklamasında odağı geri ver
    if (close) close.addEventListener('click', function () {
      if (prevFocus && prevFocus.focus) setTimeout(function () { prevFocus.focus(); }, 50);
    });
  }

  /* ---- 3. CPS plan aç/kapa butonu (PDP kutusu) ---- */
  function patchApPlan() {
    var t = document.getElementById('apPlanToggle');
    if (t && !t.getAttribute('aria-label')) t.setAttribute('aria-label', 'Protection plan details');
  }

  /* ---- 4. x-tabs: role=tab çocuklara tablist ebeveyni ---- */
  function patchTabs() {
    var tabs = document.querySelectorAll('x-tabs');
    for (var i = 0; i < tabs.length; i++) {
      var t = tabs[i];
      if (t.dataset.a11yTabs) continue;
      var btns = t.querySelectorAll('button[slot="title"]');
      if (!btns.length) continue;
      t.dataset.a11yTabs = '1';
      /* tab/tablist/tabpanel deseni bu DOM yerleşiminde (panel, listenin
         çocuğu) ARIA'ya göre kurulamıyor -> geçerli DISCLOSURE desenine çevir:
         buton aria-expanded taşır, panel düz bölge olur. */
      var temizle = function () {
        if (t.getAttribute('role')) t.removeAttribute('role');
        var el, list = t.querySelectorAll('[role="tab"], [role="tabpanel"], [aria-selected]');
        for (var j = 0; j < list.length; j++) {
          el = list[j];
          if (el.getAttribute('role') === 'tab' || el.getAttribute('role') === 'tabpanel') el.removeAttribute('role');
          if (el.hasAttribute('aria-selected')) {
            el.setAttribute('aria-expanded', el.getAttribute('aria-selected'));
            el.removeAttribute('aria-selected');
          }
        }
      };
      temizle();
      /* tema JS'i rolleri geri basarsa ayni turda geri temizle */
      new MutationObserver(temizle).observe(t, { subtree: true, attributes: true, attributeFilter: ['role', 'aria-selected'] });
    }
  }

  /* ---- 5. ürün galerisi: kaydırılabilir bölge klavyeyle erişilir ---- */
  function patchGallery() {
    var gals = document.querySelectorAll('media-carousel:not([tabindex])');
    for (var i = 0; i < gals.length; i++) {
      gals[i].setAttribute('tabindex', '0');
      gals[i].setAttribute('role', 'region');
      if (!gals[i].getAttribute('aria-label')) gals[i].setAttribute('aria-label', 'Product images');
    }
  }

  function patchAll() { patchCpsModal(); patchApPlan(); patchTabs(); patchGallery(); if (cpsFocusTick) cpsFocusTick(); }

  function init() {
    if (document.body) document.body.appendChild(live);
    patchAll();
    new MutationObserver(patchAll).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
